import { FounderCard } from '../../components/FounderCard';
import { SectionWrapper } from '../../components/SectionWrapper';

import alexHeadshotUrl from '@/images/alex_headshot.jpg';
import warrenHeadshotUrl from '@/images/warren_headshot.jpg';
import styles from './about.module.css';

const founders = [
  {
    imageSrc: warrenHeadshotUrl,
    initials: 'WE',
    name: 'Dr. Warren Essey',
    paragraphs: [
      'Warren is, at heart, an educator. He earned his PhD in physics from UCLA, where his research applied machine learning to particle astrophysics — and built the first version of Kudu while he was still on campus, in support of a course he was helping teach. He has been refining the platform alongside faculty ever since.',
      'Between his doctorate and Kudu, Warren trained as a software engineer at Google, where he learned to build systems thousands of people depend on every day. He brings that engineering rigor to a product that, for him, has always been about teaching first.',
    ],
    tags: [
      { label: 'PhD, UCLA Physics' },
      { label: 'Engineer, Google' },
      { href: 'mailto:warren@kudu.com', label: 'warren@kudu.com' },
    ],
    title: 'CO-FOUNDER & CEO',
  },
  {
    imageSrc: alexHeadshotUrl,
    initials: 'AK',
    name: 'Prof. Alexander Kusenko',
    paragraphs: [
      'Alex is a co-founder of Kudu and Professor of Physics & Astronomy at UCLA. He is a theoretical physicist working at the intersection of particle physics, cosmology, and astrophysics. Over more than two decades at UCLA, his research has spanned dark matter, neutrino physics, primordial black holes, and the physics of the early universe — and he has trained generations of graduate students and postdoctoral researchers, many of whom now hold faculty positions of their own.',
      'Alex still teaches with Kudu every term, which keeps the company honest about what classrooms actually need. As academic co-founder, he sets the pedagogical direction of the platform and works directly with the faculty who build courses on it.',
    ],
    tags: [
      { label: 'Professor, UCLA Physics & Astronomy' },
      { label: 'Particle astrophysics & cosmology' },
      { href: 'mailto:kusenko@kudu.com', label: 'kusenko@kudu.com' },
    ],
    title: 'CO-FOUNDER & ACADEMIC LEAD',
  },
] as const;

export function AboutFounders() {
  return (
    <SectionWrapper background="white" data-testid="about-section-founders">
      <div className={styles.sectionStack}>
        <div className={styles.sectionHeader}>
          <p className={styles.eyebrow}>THE FOUNDERS</p>
          <h2 className={styles.sectionTitle}>
            Two academics. One question they wouldn&apos;t let go of.
          </h2>
          <p className={styles.sectionSubhead}>
            Kudu was founded by two people who still build the company together.
            One of them still teaches with it every term.
          </p>
        </div>

        <div className={styles.founderGrid}>
          {founders.map((founder) => (
            <FounderCard key={founder.name} {...founder} />
          ))}
        </div>
      </div>
    </SectionWrapper>
  );
}
